import { useTranslator } from '@bluebeam/react-i18n';
import React, { ReactElement } from 'react';

interface Props {
  type: string;
  count?: number;
  handleClick?: () => void;
}

const EmptyResultsRow = (props: Props): ReactElement => {
  const { type, count, handleClick } = props;
  const { translate } = useTranslator(['emptySearchResults']);

  return (
    <div id="empty-results-row">
      {type === 'filter' ? (
        <div
          className="flex row justify-between items-center bgd-white"
          style={{
            borderRight: '1px var(--border-2-color) solid',
            color: 'var(--dark-grey-2)',
          }}
        >
          <div>
            <h3
              className="inline-block py4 pl4 pr3 font-size-4 bold"
              style={{
                color: 'var(--dark-grey-1)',
              }}
            >
              {translate('emptySearchResults:filter')}
            </h3>
            <p className="inline-block">
              {translate('emptySearchResults:filterMsg')}
            </p>
          </div>
          <button
            className="btn-outline-primary btn-sm mr4 inline-block"
            onClick={handleClick}
          >
            {translate('emptySearchResults:filterBtn')} ({count})
          </button>
        </div>
      ) : (
        <div
          className="flex row justify-start items-center bgd-white"
          style={{
            borderRight: '1px var(--border-2-color) solid',
            color: 'var(--dark-grey-2)',
          }}
        >
          <h3
            className="py4 pl4 pr3 font-size-4 bold"
            style={{
              color: 'var(--dark-grey-1)',
            }}
          >
            {translate('emptySearchResults:search')}
          </h3>
          <p>{translate('emptySearchResults:searchMsg')}</p>
        </div>
      )}
    </div>
  );
};

export default EmptyResultsRow;
